import React, {Component} from 'react';
import {Settings} from "../Utils/Settings";
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import Grid from '@material-ui/core/Grid';
import {Helmet} from "react-helmet";
import Typography from "@material-ui/core/es/Typography/Typography";
import Helpers from "../Utils/Helpers";
import Card from '@material-ui/core/Card';
import Button from "@material-ui/core/Button";
import ResponsiveEmbed from "react-responsive-embed";
import { Link } from "react-router-dom"
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";

import {
    FacebookShareButton,
    TwitterShareButton,
    PinterestShareButton,
    EmailShareButton,
} from 'react-share';

import {
    FacebookIcon,
    TwitterIcon,
    PinterestIcon,
    EmailIcon,
} from 'react-share';

import {ReducedButton, SoldButton, PrintButton} from "./Buttons";

class DetailsInventory extends Component {

    render() {

        const details = this.props.searchDetailsRecord;

        if (!details) {
            return "";
        }

        let images = [];
        let firstImage = "";

        images = details.media.filter(x=>x.type === 2).map(val => {
           if (firstImage.length === 0) {
               firstImage = val.xPath;
           }

           return {
               original: val.xPath,
               thumbnail: val.xPathThumbnail,
               description: val.caption
           }
        });

        let normalPrice = parseFloat(details.price).toFixed(2);
        let priceComponent = null;
        if (normalPrice > 0) {
            priceComponent = <Typography variant='h5'>${Helpers.formatMoney(normalPrice)}<br/></Typography>
        }
        let pageTitle = details.title;
        let pageCanonicalUrl = details.canonicalUrl;
        let trackingImage = "https://dashboard.equinemediaworld.com/Listing/Impression?lt=" + Settings.inventoryTypes.INVENTORY + "&id=" + details.listingId;

        let mapsComponent = null;
        if (details.contactState !== "" || details.contactCity !== ""){
            let mapsUrl = Helpers.getMapsUrl(details.contactStreet, details.contactCity, details.contactState, details.contactZip);
            mapsComponent = <React.Fragment><ResponsiveEmbed  src={mapsUrl}  ratio='4:3' allowFullScreen></ResponsiveEmbed></React.Fragment>
        }

        let shareUrl = Settings.socialShareUseCanonicalUrls ? pageCanonicalUrl : window.location.href;

        let reducedButton = details.reduced ?
            <React.Fragment><ReducedButton/><br/></React.Fragment> :
            null;

        let soldButton = details.isSold  ?
            <React.Fragment><SoldButton/><br/></React.Fragment> :
            null;

        let extraDetailsComponent =
            <Paper>
            <Table>
                <TableBody>
                {
                    details.optionSelections.map((category, categoryIndex) =>
                    {
                        return (<React.Fragment key={categoryIndex}>
                        <TableRow>
                            <TableCell colSpan={2}>{category.optionCategoryName}</TableCell>
                        </TableRow>

                        {
                            category.selections.answers.map((answer, answerIndex) => {
                                let rowKey = categoryIndex + "-" + answerIndex;
                                if (answer.optionType === Settings.inventoryFieldType.MULTIPLE ||
                                    answer.optionType === Settings.inventoryFieldType.MULTIPLEWITHTEXT ||
                                    answer.optionType === Settings.inventoryFieldType.RADIO ||
                                    answer.optionType === Settings.inventoryFieldType.RADIOWITHTEXT ||
                                    answer.optionType === Settings.inventoryFieldType.SELECT ||
                                    answer.optionType === Settings.inventoryFieldType.SELECTWITHTEXT ||
                                    answer.optionType === Settings.inventoryFieldType.AUTOCOMPLETE) {
                                    return <TableRow key={rowKey}>
                                        <TableCell><strong>{answer.name}</strong></TableCell>
                                        <TableCell>
                                                {
                                                    answer.values.map((option, multianswerIndex)=> {
                                                        return <React.Fragment key={multianswerIndex}>{option}<br/></React.Fragment>
                                                    })
                                                }
                                        </TableCell>
                                    </TableRow>
                                }

                                if (answer.optionType === Settings.inventoryFieldType.TEXTAREA)
                                {
                                    return <TableRow key={rowKey}>
                                        <TableCell><strong>{answer.name}</strong></TableCell>
                                        <TableCell>
                                            <Typography variant='body2' dangerouslySetInnerHTML={{__html: Helpers.safeHtml(answer.values[0])}}></Typography>
                                        </TableCell>
                                    </TableRow>
                                }

                                if (answer.optionType === Settings.inventoryFieldType.TEXTBOX ||
                                    answer.optionType === Settings.inventoryFieldType.NUMBER ||
                                    answer.optionType === Settings.inventoryFieldType.YEAR ||
                                    answer.optionType === Settings.inventoryFieldType.DATE)
                                {
                                    return <TableRow key={rowKey}>
                                        <TableCell><strong>{answer.name}</strong></TableCell>
                                        <TableCell>
                                            {answer.values[0]}
                                        </TableCell>
                                    </TableRow>
                                }

                                if (answer.optionType === Settings.inventoryFieldType.YESNO)
                                {
                                    return <TableRow key={rowKey}>
                                        <TableCell><strong>{answer.name}</strong></TableCell>
                                        <TableCell>
                                            {answer.values[0]===1 ? "Yes" : "No"}
                                        </TableCell>
                                    </TableRow>
                                }

                                if (answer.optionType === Settings.inventoryFieldType.STATE)
                                {
                                    return <TableRow key={rowKey}>
                                        <TableCell><strong>{answer.name}</strong></TableCell>
                                        <TableCell>
                                            {answer.values[0]}
                                        </TableCell>
                                    </TableRow>
                                }

                                if (answer.optionType === Settings.inventoryFieldType.VIDEOLINK)
                                {
                                    let videoUrl = Helpers.getVideoEmbedUrl(answer.values[0]);

                                    return (videoUrl) ?
                                    <TableRow key={rowKey}>
                                        <TableCell colSpan={2} align={"center"}><ResponsiveEmbed src={videoUrl} allowFullScreen></ResponsiveEmbed></TableCell>
                                    </TableRow> : null;
                                }

                                // Unknown
                                return <React.Fragment/>
                            })
                        }</React.Fragment>)
                    })
                }
                <TableRow>
                    <TableCell colSpan={2}><Typography variant='body1' dangerouslySetInnerHTML={{__html: Helpers.safeHtml(details.description)}}></Typography></TableCell>
                </TableRow>
                </TableBody>
            </Table></Paper>;

        return (
            <div>
            <Grid container spacing={24}>
                <Helmet>
                    <title>{pageTitle}</title>
                    <link rel="canonical" href={pageCanonicalUrl}/>
                    <meta name="og:url" content={pageCanonicalUrl}/>
                    <meta name="og:image" content={firstImage}/>
                    <meta name="og:type" content="product"/>
                    <meta name="twitter:card" content="summary"/>
                </Helmet>
                <Grid item xs={12}>
                    <Link style={{textDecoration: "none"}} to={"/inventory/" + details.listingCategoryId}><Button style={{marginBottom: "15px"}} variant="contained" color="default">Back</Button></Link>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant='h1'>{pageTitle}</Typography>
                </Grid>
                <Grid item sm={7} xs={12}>
                    <ImageGallery items={images}/>
                </Grid>
                <Grid item sm={5} xs={12}>
                    <Card style={{padding: "10px"}}>
                        {priceComponent} {reducedButton}{soldButton}
                        <Typography style={{marginBottom: "10px"}} variant='h5'>Contact</Typography>
                        <Typography variant='body2' style={{lineHeight: 2}}>
                            {details.contactStreet.length > 0 && <React.Fragment>{details.contactStreet}<br/></React.Fragment>}
                            {details.contactCity.length > 0 && <React.Fragment>{details.contactCity}, {details.contactState}<br/></React.Fragment>}
                            {details.contactZip.length > 0 && <React.Fragment>{details.contactZip}<br/></React.Fragment>}
                            {details.contactEmail.length > 0 && <React.Fragment><strong>Email:</strong> <a href={"mailto:" + details.contactEmail}>{details.contactEmail}</a><br/></React.Fragment>}
                            {details.contactWeb.length > 0 && <React.Fragment><a href="{details.contactWeb}">{details.contactWeb}</a><br/></React.Fragment>}
                            {details.contactPhone.length > 0 && <React.Fragment><strong>Phone:</strong> {details.contactPhone}<br/></React.Fragment>}
                            {details.contactPhoneTollFree.length > 0 && <React.Fragment><strong>Toll-free:</strong> {details.contactPhoneTollFree}<br/></React.Fragment>}
                            {details.contactCell.length > 0 && <React.Fragment><strong>Cell:</strong> {details.contactCell}<br/></React.Fragment>}
                            {details.contactFax.length > 0 && <React.Fragment><strong>Fax:</strong> {details.contactFax}<br/></React.Fragment>}
                            {details.contactBestTime.length > 0 && <React.Fragment><strong>Best time:</strong> {details.contactBestTime}<br/></React.Fragment>}
                        </Typography>
                        {mapsComponent}
                        <div style={{marginTop: 10}}>
                            <FacebookShareButton style={{display: "inline-block", marginRight: "10px"}} url={shareUrl}><FacebookIcon round size={32} /></FacebookShareButton>
                            <TwitterShareButton style={{display: "inline-block", marginRight: "10px"}} url={shareUrl}><TwitterIcon round size={32} /></TwitterShareButton>
                            <PinterestShareButton style={{display: "inline-block", marginRight: "10px"}} media={firstImage} url={shareUrl}><PinterestIcon round size={32} /></PinterestShareButton>
                            <EmailShareButton style={{display: "inline-block", marginRight: "10px"}} url={shareUrl}><EmailIcon round size={32} /></EmailShareButton>
                        </div>

                        <Typography align={"right"}><PrintButton/></Typography>
                    </Card>
                </Grid>
                <Grid item xs={12}>
                    {extraDetailsComponent}
                    <img alt="" src={trackingImage} />
                </Grid>

            </Grid>
            </div>
        )
    }
}

export default (DetailsInventory);

